
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './CorporateLogoNavigation.css';
import { Title } from '../../importCL';
import { useWidthContext } from '../../providers/Width';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

type TCorporateLogoNavigationItem = { 
    desktopImagePath?: string,
    mobileImagePath?: string,
    imageAltText?: string,
    imageURL?: string
}

export type THeadingTag = 'h1' | 'h2';
export type TBackgroundColor = 'white' | 'lightGrey' | 'lightBlue' | 'blue' | 'purple';

type TCorporateLogoNavigationProps = MappedComponentProperties & {
    heading?: string,
    headingTag?: THeadingTag,
    subHeading?: string,
    backgroundColor?: TBackgroundColor,
    corporateLogoItems?: TCorporateLogoNavigationItem[]
}

export const CorporateLogoNavigationEditConfig = {
    emptyLabel: 'Corporate Logo Navigation',
    isEmpty: (props: PropsWithChildren<TCorporateLogoNavigationProps>) => {
        return !props || !props?.corporateLogoItems;
    }
};

const CorporateLogoNavigation = (props: PropsWithChildren<TCorporateLogoNavigationProps>): JSX.Element => {
    const { width } = useWidthContext();
    const [startJustifyLogos, setStartJustifyLogos] = useState<boolean>(false);

    useEffect(() => {
        if(
            (props?.corporateLogoItems?.length === 2) || 
            (props?.corporateLogoItems?.length === 5) || 
            (props?.corporateLogoItems?.length === 8) || 
            (props?.corporateLogoItems?.length === 11)
        ){
            setStartJustifyLogos(true);
        }
    }, []);

    return (
        <div className={`CorporateLogoNavigation CorporateLogoNavigation--${props?.backgroundColor || 'white'} w-full ${!(props?.heading || props?.subHeading) ? 'justify-self-center' : '' }`}>
            <div className={`CorporateLogoNavigation__container ${!(props?.heading || props?.subHeading) ? 'w-[72rem] md:w-full justify-start' : '' }`}>
                {(props?.heading || props?.subHeading) && 
                    <div className='CorporateLogoNavigation__headingText'>
                        <Title
                            tag={props?.headingTag ?? 'h1'}
                            className={'CorporateLogoNavigation__title'}
                            align={'left'}
                            spanTitle={transformHTMLParserLinks(props?.subHeading) ?? null}
                            verticalBar >
                            {transformHTMLParserLinks(props?.heading)}
                        </Title>
                    </div>
                }
                <div className={`CorporateLogoNavigation__logoArray ${startJustifyLogos ? 'justify-start' : 'justify-center'}`}>
                    {props?.corporateLogoItems?.map((navigationItem: TCorporateLogoNavigationItem) => {
                        if (width >= 769) {
                            return (
                                <LinkWrapper href={navigationItem?.imageURL} className={`CorporateLogoNavigation__logoItem`}>
                                    <img src={navigationItem?.desktopImagePath} alt={navigationItem?.imageAltText}/>
                                </LinkWrapper>
                            );
                        } else {
                            return (
                                <LinkWrapper href={navigationItem?.imageURL} className={`CorporateLogoNavigation__logoItem`}>
                                    <img src={navigationItem?.mobileImagePath} alt={navigationItem?.imageAltText}/>
                                </LinkWrapper>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
};

export default CorporateLogoNavigation;
        